import { render, staticRenderFns } from "./QuestionJoiner.vue?vue&type=template&id=4c2791c0&scoped=true&"
import script from "./QuestionJoiner.vue?vue&type=script&lang=js&"
export * from "./QuestionJoiner.vue?vue&type=script&lang=js&"
import style0 from "./QuestionJoiner.vue?vue&type=style&index=0&id=4c2791c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2791c0",
  null
  
)

export default component.exports